import React from "react";

const About = () => {
  return (
    <div className="about-section container">
        <h2 className="text-center my-5">About Us</h2>
      <p className="fs-4">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestiae
        repudiandae architecto qui adipisci in officiis, aperiam sequi atque
        perferendis eos, autem maiores nisi saepe quisquam hic odio consectetur
        nobis veritatis quasi explicabo obcaecati doloremque? Placeat ratione
        hic aspernatur error blanditiis?
      </p>
    </div>
  );
};

export default About;
